// //venus// Lightbox binder compartilhado entre sections/customer-photos.liquid e sections/customer-photos-static.liquid.
// Cada section emite um wrapper [data-customer-photos-section="{section.id}"] e um <modal-dialog id="CustomerPhotosModal-{section.id}">.
(function () {
  function bind(scope) {
    if (!scope || !scope.querySelectorAll) return;
    var sections = scope.matches && scope.matches('[data-customer-photos-section]')
      ? [scope]
      : scope.querySelectorAll('[data-customer-photos-section]');
    Array.prototype.forEach.call(sections, function (section) {
      if (section.dataset.cpBound === '1') return;
      section.dataset.cpBound = '1';
      var sectionId = section.dataset.customerPhotosSection;
      var modal = document.getElementById('CustomerPhotosModal-' + sectionId);
      if (!modal) return;
      var modalImg = modal.querySelector('.customer-photos__modal-img');
      var buttons = section.querySelectorAll('.customer-photos__open-btn');
      Array.prototype.forEach.call(buttons, function (btn) {
        btn.addEventListener('click', function () {
          var src = btn.dataset.modalSrc;
          var alt = btn.dataset.modalAlt || '';
          if (modalImg && src) {
            modalImg.src = src;
            modalImg.alt = alt;
          }
          if (typeof modal.show === 'function') {
            modal.show(btn);
          }
        });
      });
    });
  }

  bind(document);
  document.addEventListener('shopify:section:load', function (event) {
    bind(event.target);
  });
})();
